<template>
  <div v-if="composition.sellables.length && sellableImages.length">
    <div class="sellable-grid">
      <div
        v-for="sellableImage in limitedSellableImages"
        :key="sellableImage[0]"
        class="sellable"
      >
        <img :src="`${sellableImage[0]}`" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Composition } from '@spreadgroup/common-partner-lib/composition';
import compositionHelper from 'commons/composition/compositionHelper';

const props = defineProps<{
  composition: Composition;
  max?: number;
}>();

const hasMultipleDesigns = compositionHelper.hasMultipleDesigns(
  props.composition,
);

const sellableImages = computed(() =>
  hasMultipleDesigns
    ? compositionHelper.getAllActivatedSellableImages(props.composition)
    : compositionHelper.getDefaultActivatedSellableImages(props.composition),
);

const limitedSellableImages = computed(() =>
  props.max ? sellableImages.value.slice(0, props.max) : sellableImages.value,
);
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';

.sellable-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 12px;
  width: 100%;

  .sellable {
    background-color: $grey5;
    padding: 4px;
    aspect-ratio: 90 / 110;
    min-height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: $border-radius-medium;
    border: 1px solid $grey10;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

button {
  margin-top: 12px;
}
</style>
